const signalR = require("@microsoft/signalr");

export const signalRConnection = () => {
  return new signalR.HubConnectionBuilder()
    .withUrl(`${process.env.REACT_APP_API_HOST}/SignalRHubs/RealtimeVehicle`, {
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
      accessTokenFactory: () => localStorage.getItem("token"),
    })
    .withAutomaticReconnect([0, 2000, 10000, 30000])
    .configureLogging(signalR.LogLevel.Information)
    .build();
  // return new signalR.HubConnectionBuilder()
  //   .withUrl(`http://localhost:8080/`, {
  //     skipNegotiation: true,
  //     transport: signalR.HttpTransportType.WebSockets,
  //     accessTokenFactory: () => localStorage.getItem("token"),
  //   })
  //   .configureLogging(signalR.LogLevel.Information)
  //   .build();
};
